// components/Contact/Contact.jsx
import React, { useState, useEffect } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../firebase";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: "", message: "" });
  const [isVisible, setIsVisible] = useState(false);
  const [activeInfo, setActiveInfo] = useState("email");

  useEffect(() => {
    const handleScroll = () => {
      const section = document.querySelector(".contact");
      if (section) {
        const rect = section.getBoundingClientRect();
        setIsVisible(rect.top < window.innerHeight && rect.bottom > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    // Clear error when user starts typing
    if (submitStatus.type === "error") {
      setSubmitStatus({ type: "", message: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitStatus({ type: "", message: "" });

    try {
      // Add the form data to Firestore
      const docRef = await addDoc(collection(db, "contacts"), {
        ...formData,
        submittedAt: new Date().toISOString(),
        status: "unread",
        source: "website",
      });

      console.log("Document written with ID: ", docRef.id);

      // Show success message
      setSubmitStatus({
        type: "success",
        message:
          "🎉 Message sent successfully! We'll get back to you within 24 hours.",
      });

      // Reset form
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });

      // Clear success message after 5 seconds
      setTimeout(() => {
        setSubmitStatus({ type: "", message: "" });
      }, 5000);
    } catch (error) {
      console.error("Error adding document: ", error);
      setSubmitStatus({
        type: "error",
        message:
          "❌ Failed to send message. Please try again or contact us directly.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const contactInfo = [
    {
      id: "email",
      icon: "✉️",
      title: "Email Us",
      value: "contact@jobhubmanpowersolution.com ",
      link: "mailto:support@jobhub manpower solution.com",
      color: "#1e3a8a",
    },
    // {
    //   id: "phone",
    //   icon: "📞",
    //   title: "Call Us",
    //   value: "+91 9152526979",
    //   link: "tel:+917021117127",
    //   color: "#3730a3",
    // },
    {
      id: "location",
      icon: "📍",
      title: "Visit Us",
      value: "Mumbai, Maharashtra",
      link: "#",
      color: "#f59e0b",
    },
  ];

  return (
    <section className="contact" id="contact">
      <div className="contact-bg-pattern"></div>

      <div className="contact-container">
        {/* Header */}
        <div className={`contact-header ${isVisible ? "animate-in" : ""}`}>
          <h2 className="contact-title">
            Let's <span className="gradient-text">Connect</span>
          </h2>
          <p className="contact-subtitle">
            Have questions? We'd love to hear from you. Send us a message and
            we'll respond as soon as possible.
          </p>
        </div>

        <div className="contact-content">
          {/* Left Side - Contact Info & Image */}
          <div className="contact-left">
            {/* Contact Info Cards */}
            <div className="contact-info-grid">
              {contactInfo.map((info, index) => (
                <a
                  key={info.id}
                  href={info.link}
                  className={`contact-info-card ${
                    isVisible ? "slide-in" : ""
                  } ${activeInfo === info.id ? "active" : ""}`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                  onMouseEnter={() => setActiveInfo(info.id)}
                >
                  <div
                    className="info-icon"
                    style={{ background: `${info.color}20` }}
                  >
                    <span style={{ fontSize: "2rem" }}>{info.icon}</span>
                  </div>
                  <div className="info-content">
                    <h4>{info.title}</h4>
                    <p>{info.value}</p>
                  </div>
                  <div className="info-arrow">→</div>
                </a>
              ))}
            </div>

            {/* Image Section */}
            <div
              className={`contact-image-wrapper ${isVisible ? "scale-in" : ""}`}
            >
              <div className="floating-shapes">
                <div className="shape shape-1"></div>
                <div className="shape shape-2"></div>
                <div className="shape shape-3"></div>
              </div>
              <div className="contact-image">
                <div className="image-circle">
                  <img
                    src="/api/placeholder/400/400"
                    alt="Contact jobhub manpower solution"
                  />
                  <div className="image-badge">
                    <span className="badge-icon">💬</span>
                    <span className="badge-text">24/7 Support</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Working Hours */}
            {/* <div className={`working-hours-card ${isVisible ? 'fade-in' : ''}`}>
              <h4>🕐 Working Hours</h4>
              <div className="hours-grid">
                <div className="hour-item">
                  <span className="day">Mon - Fri</span>
                  <span className="time">9:00 AM - 8:00 PM</span>
                </div>
                <div className="hour-item">
                  <span className="day">Saturday</span>
                  <span className="time">10:00 AM - 6:00 PM</span>
                </div>
                <div className="hour-item">
                  <span className="day">Sunday</span>
                  <span className="time">10:00 AM - 4:00 PM</span>
                </div>
              </div>
            </div> */}
          </div>

          {/* Right Side - Contact Form */}
          <div className="contact-right">
            <div
              className={`contact-form-card ${
                isVisible ? "slide-in-right" : ""
              }`}
            >
              <h3 className="form-title">Send us a Query</h3>

              {submitStatus.message && (
                <div
                  className={`status-message ${submitStatus.type} ${
                    isVisible ? "slide-down" : ""
                  }`}
                >
                  {submitStatus.message}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>First Name *</label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder="John"
                      required
                      disabled={submitting}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Last Name *</label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder="Doe"
                      required
                      disabled={submitting}
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="john.doe@example.com"
                      required
                      disabled={submitting}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Phone</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+91 98765 43210"
                      disabled={submitting}
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Subject</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="How can we help you?"
                    disabled={submitting}
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label>Message *</label>
                  <textarea
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us more about your inquiry..."
                    required
                    disabled={submitting}
                    className="form-input form-textarea"
                  />
                  <span className="char-count">
                    {formData.message.length}/500 characters
                  </span>
                </div>

                <button
                  type="submit"
                  className={`submit-btn ${submitting ? "loading" : ""}`}
                  disabled={submitting}
                >
                  <span className="btn-text">
                    {submitting ? "Sending..." : "Send Message"}
                  </span>
                  <span className="btn-icon">{submitting ? "⏳" : "🚀"}</span>
                </button>
              </form>

              <div className="form-footer">
                <p className="privacy-note">
                  🔒 Your information is safe with us. We respect your privacy.
                </p>
              </div>
            </div>

            {/* App Download Section */}
            {/* <div className={`app-download-card ${isVisible ? "fade-in" : ""}`}>
              <div className="app-content">
                <h4>Get the jobhub manpower solution App</h4>
                <p>Join thousands of users earning daily!</p>
              </div>
              <div className="app-buttons">
                <button
                  className="app-store-btn"
                  onClick={() => alert("jobhub manpower solution app coming soon!")}
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                    alt="Get it on Google Play"
                  />
                </button>
              </div>
            </div> */}
          </div>
        </div>

        {/* Bottom FAQ Section */}
        {/* <div className={`contact-faq ${isVisible ? "fade-in" : ""}`}>
          <h3>Frequently Asked Questions</h3>
          <div className="faq-grid">
            <div className="faq-item">
              <span className="faq-icon">🤔</span>
              <h5>How quickly will you respond?</h5>
              <p>We typically respond within 24 hours during business days.</p>
            </div>
            <div className="faq-item">
              <span className="faq-icon">📱</span>
              <h5>Can I track my inquiry?</h5>
              <p>
                Yes! You'll receive an email confirmation with a tracking ID.
              </p>
            </div>
            <div className="faq-item">
              <span className="faq-icon">🌟</span>
              <h5>Do you offer phone support?</h5>
              <p>Yes, call us during working hours for immediate assistance.</p>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Contact;
